// extracted by mini-css-extract-plugin
export default {"icon":"Label_icon__IenCM","image":"Label_image__bMuIY","marginLeft":"Label_marginLeft__l-KKs"};